import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Dropdown, Input } from 'semantic-ui-react';
import AssetPicker from '../../../brands/AssetPicker';
import { fetchMenu, uploadImage, deleteImage } from '../../../../../actions';
import { DateRangePicker } from '../../../../common';
import moment from 'moment';

import './ProductPromotionSettings.scss';
import i18next from 'i18next';

export const ProductPromotionSettings = (props) => {
    const { settings, handleSettingsUpdate, menuId } = props;
    const menuItems = Object.values(useSelector(state => state.businessApp.menu.items)).map(item => ({ key: item.id, text: item.name, value: item.id }));
    const dispatch = useDispatch();

    useEffect(() => {
        if (menuItems.length === 0) {
            dispatch(fetchMenu(menuId, null, true));
        }
    }, [menuItems]);

    useEffect(() => {
        if (!settings.startDate) {
            handleSettingsUpdate({ ...settings, startDate: moment().startOf('day'), endDate: moment().startOf('day').add(14, 'days')});
        }
    }, []);

    return (
        <Form className="settings">
            <div className="col">
                <div className="setting-container">
                    <Form.Field>
                        <label>{i18next.t('smartPromotions.promotion.settings.chooseItem')}</label>
                    </Form.Field>
                    <div style={{ display: 'flex' }}>
                        <Dropdown
                            search
                            selection
                            loading={Object.keys(menuItems).length === 0}
                            placeholder={i18next.t('smartPromotions.promotion.settings.searchItem')}
                            value={settings.itemId}
                            onChange={(e, data) => handleSettingsUpdate({ ...settings, itemId: data.value })}
                            options={menuItems}
                        />
                    </div>

                    <Form.Field>
                        <label>{i18next.t('smartPromotions.promotion.settings.chooseDates')}</label>
                    </Form.Field>
                    <div style={{ display: 'flex' }}>
                        <DateRangePicker
                            value={[
                                settings.startDate ? moment(settings.startDate) : moment().startOf('day'),
                                settings.endDate ? moment(settings.endDate) : moment().startOf('day').add(14, 'days')
                            ]}
                            onChange={(rangeDates) => {
                                const startDate = rangeDates[0].startOf('day');
                                const endDate = rangeDates[1].endOf('day');
                                handleSettingsUpdate({ ...settings, startDate, endDate });
                            }}
                            enableFutureDate
                        />
                    </div>

                    <Form.Field>
                        <label>{i18next.t('smartPromotions.promotion.settings.overridePrice')}</label>
                    </Form.Field>
                    <div style={{ display: 'flex' }}>
                        <Input placeholder={i18next.t('smartPromotions.promotion.settings.overridePricePlaceholder')}
                            value={settings.price}
                            onChange={(e, { value }) => {
                                handleSettingsUpdate({ ...settings, price: !value || isNaN(value) ? '' : Number(value) });
                            }}
                        />
                    </div>
                </div>
                <div className="setting-container">
                    <Form.Field>
                        <label>{`${i18next.t('smartPromotions.promotion.settings.addBanner')} - 1080x360`}</label>
                    </Form.Field>
                    <div style={{ display: 'flex' }}>
                        <AssetPicker
                            className={`promotion banner`}
                            source={settings.bannerUrl}
                            onUpload={file => dispatch(uploadImage(file, 'smartPromotionBanner', 'cover', (data) => {
                                handleSettingsUpdate({ ...settings, bannerUrl: data.imageUrl, bannerGuid: data.imageGuid });
                            }))}
                            onDelete={() => handleSettingsUpdate({ ...settings, bannerUrl: '', bannerGuid: '' })}
                        />
                    </div>
                </div>
            </div>
        </Form>
    );
};

ProductPromotionSettings.propTypes = {
    handleSettingsUpdate: PropTypes.func,
    menuId: PropTypes.string,
    settings: PropTypes.object
};